(function() {
  'use strict';

  angular.module('eclipseApp.myAccount').controller('internetUsageNotificationCtrl', ['$scope', '$http', 'uteEndpoint', '$stateParams', '$rootScope', '$state', function($scope, $http, uteEndpoint, $stateParams, $rootScope, $state) {
    
    // DC-188: code cleanup, following moved to route resolve
    
    /* if ($stateParams.accountNumber && $stateParams.subscriberNo) {
      $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
      $rootScope.userInfo.selectedSubscriberNo = $stateParams.subscriberNo;
    } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) || (!$stateParams.subscriberNo && !$rootScope.userInfo.selectedSubscriberNo)) {
      $state.go('myAccount.overview');
    } else {
      if (!$stateParams.accountNumber) {
        $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
      }
      if (!$stateParams.subscriberNo) {
        $stateParams.subscriberNo = $rootScope.userInfo.selectedSubscriberNo;
      }
    } */

    $scope.accountNumber = $stateParams.accountNumber || $rootScope.userInfo.selectedAccountNumber;
    $scope.subscriberNo = $stateParams.subscriberNo || $rootScope.userInfo.selectedSubscriberNo;

    var url = uteEndpoint('v1/productNotificationHistory');
    $http.post(url, {
      accountNumber: $scope.accountNumber,
      subscriptionID: $scope.subscriberNo
    }).success(function(data) {
      $scope.usageHistoryData = [];


      $scope.usageHistoryData = data.getUsageNotifications.notification;
      console.log(  $scope.usageHistoryData );
    });


    var summaryUrl = uteEndpoint('v1/productConsolidatedUsageSummary');
    $http.post(summaryUrl, {
      prodSpec: 'hsi',
      accountNumber: $scope.accountNumber,
      subscriptionID: $scope.subscriberNo
    }).then(function (resp) {
      $scope.usageSummary = resp.data.getDataHSIUsageSummary;
    });

  }]);

})();
